<script>
import { authComputed } from '@state/helpers'
export default {
	components: {},
	props: {
		user: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		isMenuOpened: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {}
	},
	computed: {
		...authComputed,
	},
	methods: {
        toggleLeftSidebar(){
            var sidebar = document.getElementById('leftsidebar');
            var status = sidebar.style.display;
            sidebar.style.display = status == '' ? 'block' : '';
        }
	},
}
</script>
<template>
    <div class="navbar navbar-expand flex-column flex-md-row navbar-custom">
        <div class="container-fluid">
            <!-- LOGO -->
            <a href="/" class="navbar-brand mr-0 mr-md-2 logo">
                <span><img src="@assets/images/logo.png" alt="" height="46" /></span>               
            </a>                
            <span class="d-inline h5 text-logo" style="position: relative; padding-top: 20px;">建科环境</span>
            <ul class="navbar-nav bd-navbar-nav flex-row list-unstyled menu-left mb-0">
                <li class="">
                    <button class="button-menu-mobile open-left disable-btn" @click="toggleLeftSidebar">
                        <feather type="menu" class="menu-icon align-middle"></feather>
                        <feather type="x" class="close-icon"></feather>
                    </button>
                </li>
            </ul>
            <ul class="navbar-nav flex-row ml-auto d-flex list-unstyled topnav-menu float-right mb-0">
                <li class="d-none d-sm-block">
                    <div class="app-search">
                        <form>
                            <div class="input-group">
                                <input type="text" class="form-control" placeholder="Search..." />
                                <feather type="search" class="align-middle"></feather>
                            </div>
                        </form>
                    </div>
                </li>
				<li	id="setting-tooltip" class="dropdown notification-list"	title="账号设置">
					<a href="/profile" class="nav-link right-bar-toggle toggle-right">
						<feather type="user" class="toggle-right"></feather>
					</a>
					<b-tooltip target="setting-tooltip" placement="left">账号设置</b-tooltip>
				</li>                
				<li	id="logout-tooltip" class="dropdown notification-list"	title="登出">
					<a href="/logout" class="nav-link right-bar-toggle toggle-right">
						<feather type="log-out" class="toggle-right"></feather>
					</a>
					<b-tooltip target="logout-tooltip" placement="left">登出</b-tooltip>
				</li>
            </ul>
        </div>
    </div>
</template>